import { isArray } from 'util';
import { mapCollection, sortByString } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { Material } from '../material';

export class MaterialBuilder {
  static fromJson(json) {
    return (json)
      ? new Material(
        json.hash,
        json.fileName,
        json.code,
        parseNumber(json.amount),
        json.planeNumber,
        json.denomination,
        json.brand,
        json.reference,
        json.category,
        json.subcategory,
        json.subcategoryName,
        json.printNumber,
        json.bluePrintPath,
        parseNumber(json.lastUpdate),
        parseNumber(json.sequenceNumber),
        parseNumber(json.pieceQuantity),
        parseNumber(json.quantity),
        parseNumber(json.orderNumber),
        json.addByHand,
        json.deliveryDate
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? sortByString('code', mapCollection(MaterialBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/material.builder.ts